import { Col, Row } from "react-bootstrap";
import { FormProvider } from "react-hook-form";
import { AccordionCard, Button, useAccordionWizard } from "..";

export const AccordionForm = ({
  accordionTitle,
  accordionKey,
  isPreLoading,
  isPostLoading,
  form,
  onSubmit,
  children,
}) => {
  const { accordionKeys } = useAccordionWizard();
  const isLastAccordion =
    accordionKeys.findIndex((key) => key === accordionKey) ===
    accordionKeys.length - 1;
  return (
    <div className={"mt-4"}>
      <AccordionCard
        headerText={accordionTitle}
        accordionKey={accordionKey}
        loading={isPreLoading}
      >
        <FormProvider {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)}>
            {children}

            <Row className={"mt-5"}>
              <Col />
              <Col xs={2}>
                <Button
                  label={isLastAccordion ? "Save" : "Save and Next"}
                  loading={isPostLoading}
                />
              </Col>
            </Row>
          </form>
        </FormProvider>
      </AccordionCard>
    </div>
  );
};
